export default {
    invalid_title: "Coupon {0} is invalid",
    utilizing_title: "Using coupon {0}",
    error_expired: "Coupon expired",
    error_not_yet_valid: "Coupon will be valid from",
    error_used: "Coupon already used",
    error_not_found: "Code not found",
    benefit_prefix: "Grant the benefit of",
    irreversible: "This action is irreversible.",
    purchase_value_label:
        "What is the value of the purchase the customer is making?",
    order_value_placeholder: "Order value",
    min_value_error: "The value must be higher than R${0}",
    discount_label: "Discount: R${0}",
    close_button: "Close",
    confirm_button: "Confirm use",
    used_title: "Coupon {0} was used",
    used_success: "{0} coupon was used successfully.",
    used_invalid_now: "Coupon {0} is no longer valid",
    generic_error: "Something went wrong, please try again later",
    incentive_text_label: "Incentive text",
    probability_label: "Probability",
    name_locked_tooltip:
        "This coupon already has generated codes and cannot be removed or have its name changed.",
    generated_singular: "generated",
    generated_plural: "generated",
    conjunction_and: "and",
    used_singular: "redeemed",
    used_plural: "redeemed",
    delete_coupon: "Delete coupon",
    remove_notice: "Coupon {0} will be removed when saving.",
    undo: "Undo",
    empty_prefix: "You don't have any coupons yet,",
    empty_cta: "create the first one now!",
    new_coupon: "New Coupon",
    registered_coupons: "Registered coupons",
    total_probability_error:
        "The sum of probabilities must be 100 but is currently {0}",
    saved_success: "Saved successfully",
    save_button: "Save",
    page_title: "Kevi | Coupons",
};
